// extracted by mini-css-extract-plugin
module.exports = {"tabMenu":"TabMenu_tabMenu__U53RY","tabMenuItem":"TabMenu_tabMenuItem__sMWQI","activeTab":"TabMenu_activeTab__RRCmO"};